import { render } from "./AddEditForm.vue?vue&type=template&id=3d96cf7f&ts=true"
import script from "./AddEditForm.vue?vue&type=script&lang=ts"
export * from "./AddEditForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__